export const UserGeolocationKeys = {
    countryCode: 'countryCode',
    continentCode: 'continentCode',
    isEUCountry: 'isEUCountry',
    timezone: 'timezone',
    city: 'city',
    region: 'region',
};
